<app-loading></app-loading>
<div class="page-wraper">
	<!-- header -->
    <app-header1 [data]="profile"></app-header1>
    <!-- header END -->
	<div class="banner-section coad-bnr">
		<canvas id="c" class="coad-bg"></canvas>
		<div class="banner-inner bnr-left">
			<h3 class="sub-title">I’ Am <span class="text-gradient">Bertrand PETIT</span></h3>
			<h2 class="title">Web Developer</h2>
			<a routerLink="/resume-{{member.profile}}" class="site-button button-md outline-half">Check My Cv</a> 
			<img src="assets/images/background/bp.png" class="main-content" alt=""/>			
		</div>
		<app-social-bar></app-social-bar>
		<app-copywrite></app-copywrite>
		<app-user-card [data]="member"></app-user-card>
	</div>
</div>